import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { Trash2 } from "lucide-react";
import { RoleBadge, UserStatusBadge } from "@/components/ui/Badge";
const headerCellClassName = "bg-gray-100 font-bold text-gray-700 text-sm";
export const useOrganizationUserColumns = ({ canModifyUsers, currentUserId, isDeletingUser, onRequestDelete })=>{
    return useMemo(()=>{
        const baseColumns = [
            {
                field: "FullName",
                headerName: "Name",
                headerClassName: headerCellClassName,
                flex: 1,
                minWidth: 200,
                sortable: false,
                renderCell: (params)=>/*#__PURE__*/ _jsx("span", {
                        className: "text-sm font-medium text-gray-900",
                        title: params.value,
                        children: params.value
                    })
            },
            {
                field: "Email",
                headerName: "Email",
                headerClassName: headerCellClassName,
                flex: 1,
                minWidth: 250,
                sortable: false,
                renderCell: (params)=>/*#__PURE__*/ _jsx("span", {
                        className: "text-sm text-gray-500",
                        title: params.value,
                        children: params.value
                    })
            },
            {
                field: "Role",
                headerName: "Role",
                headerClassName: headerCellClassName,
                width: 135,
                sortable: false,
                renderCell: (params)=>/*#__PURE__*/ _jsx(RoleBadge, {
                        role: params.value
                    })
            },
            {
                field: "Status",
                headerName: "Status",
                headerClassName: headerCellClassName,
                width: 120,
                sortable: false,
                renderCell: (params)=>/*#__PURE__*/ _jsx(UserStatusBadge, {
                        status: params.value
                    })
            },
            {
                field: "JoinedAt",
                headerName: "Joined",
                headerClassName: headerCellClassName,
                width: 120,
                sortable: false,
                renderCell: (params)=>/*#__PURE__*/ _jsx("span", {
                        className: "text-sm text-gray-500",
                        children: new Date(params.value).toLocaleDateString()
                    })
            }
        ];
        if (!canModifyUsers) {
            return baseColumns;
        }
        return [
            ...baseColumns,
            {
                field: "actions",
                headerName: "Actions",
                headerClassName: headerCellClassName,
                width: 100,
                sortable: false,
                align: "center",
                headerAlign: "center",
                renderCell: (params)=>{
                    if (params.row.UserId === currentUserId) {
                        return null;
                    }
                    return /*#__PURE__*/ _jsx("button", {
                        onClick: (event)=>{
                            event.stopPropagation();
                            onRequestDelete(params.row);
                        },
                        className: "text-red-600 hover:text-red-800 disabled:cursor-not-allowed disabled:opacity-50",
                        disabled: isDeletingUser,
                        title: "Remove user",
                        "data-testid": `remove-user-${params.row.FullName}`,
                        children: /*#__PURE__*/ _jsx(Trash2, {
                            className: "h-4 w-4"
                        })
                    });
                }
            }
        ];
    }, [
        canModifyUsers,
        currentUserId,
        isDeletingUser,
        onRequestDelete
    ]);
};
export default useOrganizationUserColumns;
